import React from 'react';
import HomeListManager from '../admincomponents/HomeListManager';

function AdminHomeFeaturedCourses() {
  return (
    <HomeListManager
      title="Featured Courses"
      urlPath="home-featured-courses"
      imageField="image"
      emptyMessage='No featured courses yet — click "Add" to feature the first course on the homepage.'
      fields={[
        { name: 'course_page_id', label: 'Course', type: 'course-select', required: true, colClass: 'col-12' },
        { name: 'heading', label: 'Heading', required: true, placeholder: 'e.g. Mastery in Facilities Management' },
        { name: 'summary', label: 'Summary', type: 'textarea', colClass: 'col-12' },
      ]}
    />
  );
}

export default AdminHomeFeaturedCourses;
